<template>
  <header class="menu">
    <div class="logo">
      <router-link :to="{ name: 'feed' }">
        <pulse-logo-svg />
      </router-link>
      <ul>
        <li class="toggle-full" @click="toggleFull" :class="{ '-hide': !full }">
          <button>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </li>
      </ul>
    </div>
    <div class="add-menu">
      <ul class="popup-user-menu">
        <li class="toggle-full" @click="toggleFull" :class="{ '-hide': !full }">
          <button>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </li>
        <li>
          <router-link :to="{ name: 'profile_overview' }">
            <custom-image v-if="image" :source="$IMAGE(image)"></custom-image>
            <img src="/default_image.png" v-else />
          </router-link>
        </li>
      </ul>
      <ul class="add-user-menu">
        <li>
          <i @click="userLogout" class="logout-icon pe-7s-power"></i>
        </li>
      </ul>
    </div>
  </header>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState("user", {
      image: state => state.data.image
    }),
    ...mapState("app", {
      full: state => state.settings.full
    })
  },
  methods: {
    ...mapActions("app", ["setSettings", "setLoading"]),
    ...mapActions("user", ["logout"]),
    userLogout() {
      this.setLoading(true);
      this.logout();
    },
    toggleFull() {
      this.setSettings({ full: !this.full });
    }
  }
};
</script>
